import { colors } from "../../Styles";

export function FarmInfo({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M141.7,21.7L5.9,138.9l10,10v112.9h251.7v-112.9l10-10L141.7,21.7ZM139.9,86.9c9.4,0,15.3,5.9,15.3,13.3s-5.9,13.5-15.3,13.5-15.5-5.9-15.5-13.5,5.9-13.3,15.5-13.3ZM162.6,230h-41.8c-3.3,0-5.5-1.8-5.5-6.1s2.2-6.1,5.5-6.1h7.3c2.5,0,3.9-1.2,3.9-3.5v-62.7c0-2.4-1.4-3.5-3.9-3.5h-7.3c-3.3,0-5.5-1.4-5.5-6.1s2.2-6.1,5.5-6.1h25.3c3.3,0,5.5,1.8,5.5,4.9v73.5c0,2.4,1.2,3.5,3.9,3.5h7.1c3.3,0,5.5,1.2,5.5,6.1s-2.2,6.1-5.5,6.1Z"/>
    </svg>
  );
}